import SocialLink from './SocialLink';

export default function SocialLinks({ links }) {
  return (
    <div className="flex justify-end gap-4">
      {links.map((link, index) => (
        <SocialLink key={index} link={link} />
      ))}
    </div>
  );
}